// @ts-expect-error: Flow to TS migration.
import { reducer as form } from "redux-form"
// @ts-expect-error: Flow to TS migration.
import splitsterReducer from "splitster-redux"

import currencies from "./currencies/index"
import smartFAQ from "../modules/SmartFAQ/services/SmartFAQDuck"
import history from "./history/historyDuck"
import modals from "./modals/reducer"
import auth from "./auth"
import notice from "./notice"
import options from "./options/reducer"
import page from "./page/index"
import params from "./params/index"
import query from "./query/index"
import remoteConfig from "./remoteConfig/index"
import staticData from "./staticData/index"
import translations from "./intl/index"
import window from "./window/index"

const defaultReducer = {
  auth,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  countries: (state: Record<any, any> = {}) => state,
  currencies,
  form,
  history,
  modals,
  notice,
  options,
  page,
  params,
  query,
  staticData,
  translations,
  window,
  smartFAQ,
  splitster: splitsterReducer,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  splitsterConfig: (state: Record<any, any> = {}) => state,
  remoteConfig,
} as const

export default defaultReducer
